import script from "./ContactUsSlide.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactUsSlide.vue?vue&type=script&setup=true&lang=js"

import "./ContactUsSlide.vue?vue&type=style&index=0&id=eab44638&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Veverica\\Documents\\projekti\\btc-prop\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eab44638"]])

export default __exports__